export enum ResourceType {
  Space = 1, // スペース（会議室など）
  Facility = 2, // その他（設備など）
}
